export const tableHeader = (t) => [
    {
        id: 'version',
        type: 'text',
        value: t('policy:show.table.version'),
    },
    {
        id: 'publishedDate',
        type: 'datetime',
        value: t('policy:show.table.published'),
    },
    {
        id: 'reviewedDate',
        type: 'datetime',
        value: t('policy:show.table.reviewed'),
    },
    {
        id: 'approvedDate',
        type: 'datetime',
        value: t('policy:show.table.approved'),
    },
    {
        id: 'action',
        type: 'actions-policy-version',
        value: '',
    },
]
